import { latestPriceEth, convRate, } from "@bracket/platform/cachables";

import type {
  TokenIdentifier,
  AmountString,
  USD,
} from "@bracket/types";

export declare type ConvertToUSDProps = {
  token: TokenIdentifier;
  amount: AmountString;
  amountType? : "WEI" | "AmountString";
};

export const convertToUSD = async ({
  token,
  amount,
  amountType = "AmountString",
}: ConvertToUSDProps): Promise<USD> => {

  const nAmount = Number(amount);

  const [
    price,
    rate,
  ] = await Promise.all([
    latestPriceEth(),
    convRate({ token, }),
  ]);

  switch(amountType) {
    case "WEI":
      throw new Error("WEI is not supported yet");
    case "AmountString":
      return nAmount * rate * price;
    default:
      throw new Error("Invalid amount type");
  }

}
